export var getSearchPageUrl = function getSearchPageUrl(_ref) {
  var url = _ref.url,
    query = _ref.query,
    category = _ref.category;
  var params = '';
  if (query) {
    params += "term=".concat(encodeURIComponent(query.trim()));
  }
  if (category) {
    params += "&categories=".concat(category);
  }
  return "".concat(url, "?").concat(params);
};